import type { FaireProductEntity } from "../../entity_types/product";

export const p_avrciqh5ce: FaireProductEntity = {
  token: "p_avrciqh5ce",
  type: "product",
  name: "Elderberry Syrup 8.5 oz",
  brandToken: "b_22sqdcowjj",
  brandName: "Elderlane®",
  imageUrl:
    "https://cdn.faire.com/fastly/ae8a49631b8aba3d11a37d3a1a3655f27afaa0ddb17365c90368eca4c4db018d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/535173e44f320e36ac039df9a581491c1466636705cb9fd6eeec166156840212.jpeg",
    "https://cdn.faire.com/fastly/681fe9caaa0f963fa9dd09aa4a71535e5cd78c13317fe88b8061bc91b4365409.jpeg",
    "https://cdn.faire.com/fastly/f9c61f4db1cbde50aef497048e038d0683ee38a72318178c098e1ace609c4672.jpeg",
    "https://cdn.faire.com/fastly/e27486875f703db72a36f74df58f35cdf00d001f7581c5e9085dc3803292a997.jpeg",
    "https://cdn.faire.com/fastly/edf0528b7851c355d910bfb5a06cf9d34b14818f51cdd05a63d38b9a5f8efa4e.png",
    "https://cdn.faire.com/fastly/86f81d3fe12500a54a1dc5e84ae8235aced56f451b99232a1e5ba4f1bd8846f0.png",
    "https://cdn.faire.com/fastly/3830b6076fd5489465cf132ebe5020dc3db8926d6aa8838010d74920f572c97b.png",
    "https://cdn.faire.com/fastly/13eff3329e54efa5391020ff70113a90646cfd9f0000b2a628e23b9005beb5f0.png",
    "https://cdn.faire.com/fastly/54252fd0f4c4409d8245e252c9a8fa1f9e051ec6e02561ecae93e886b0dafdb7.png",
    "https://cdn.faire.com/fastly/88103400a3768b912c7c7c00be8ff5bd74a023ea8b082ab3fa6ce78fa0512396.jpeg",
    "https://cdn.faire.com/fastly/ec33bc9b9522506b0dddd655886c90f675ef18e51a3de62f964af1d45f997466.png",
  ],
  priceDollars: 12.5,
  description:
    'The original formula that started it all!  A perfect daily spoonful for immune support, Elderlane® Elderberry Syrup is a delicious blend of berries, spices, flowers and honey. Shelf-stable until opened, then refrigerated, this is a tried and true liquid bottle of goodness that’s great to have on hand for the whole family.\n\n"We\'ve tasted other brands before, and with this one, there is so much to love. Clean, simple ingredients, amazing taste, easy dosing from bottle to spoon and most importantly - it works!" - Amy\n\nSHELF-STABLE 1-2 YEARS FROM DATE OF BOTTLING\n\nINGREDIENTS: ORANIC ELDERBERRIES, HONEY, GINGER, CINNAMON, CLOVES, HIBISCUS, LEMON JUICE',
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:26.691Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
